<div class="card" *ngIf="item">
    <div class="card_img">
        <div class="cardImg">
            <img (click)="redirect($event,item)" [src]="image" alt="{{item.name ? item.name : ''}}"
                onError="this.src='./assets/images/dummy/placeholderImage.jpg'" />
        </div>
        <!-- <div class="coupon_text">
            50% Off
        </div> -->
        <div class="checkAndLike">
            <div class="check">
                <app-light-checkbox [text]="'Add to Compare'" [checked]="isItemIncludedInCompareList(item)"
                    (click)="$event.stopPropagation()"
                    (onChangeEvent)="addRemoveCompareItem($event, item)"></app-light-checkbox>
            </div>
            <div class="icn">
                <div class="comment_icon" style="cursor: pointer;"
                    (click)="!isReview && !IsWishList && doComment($event, item)">
                    <mat-icon [svgIcon]="isReview ? 'newcommentfill' : 'newcommentEmpty'"
                        class="icon-size-16"></mat-icon>
                    <span class="comment_count">{{(item.review && item.review.length) ? item.review.length :
                        0}}</span>
                </div>
                <div class="heart_icon" style="cursor: pointer;" (click)="!IsWishList && doLike($event, item)">
                    <mat-icon [svgIcon]="isLike ? 'newLikeFill' : 'newlikeEmpty'" class="icon-size-16"></mat-icon>
                    <span class="like_count">{{(item.likes && item.likes.length) ? item.likes.length : 0}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="card_text">
        <div class="card_info">
            <!-- <p class="name">{{item?.name}}</p> -->
            <p class="name">{{item.name ? item.name : ''}}</p>
            <p class="info" *ngIf="item.brand && item.brand.name">by
                <!-- <span class="info_text">{{item?.brand?.name}}</span> -->
                <span class="info_text">{{item.brand.name ? item.brand.name : '' }}</span>
            </p>
        </div>
        <div class="card_price">
            <div class="price" *ngIf="getPrice(item).length > 1">
                <!-- <span class="dis_price"> {{getPrice(item)[0]}} ₹</span>
                <span class="finalPrice"> {{getPrice(item)[1]}} ₹ </span> -->
                <span class="dis_price">
                    {{ getPrice(item)[0] % 1 === 0 ? getPrice(item)[0].toLocaleString('en-IN') : (getPrice(item)[0] |
                    number:'1.2-2') }} ₹
                </span>
                <span class="finalPrice">
                    {{ getPrice(item)[1] % 1 === 0 ? getPrice(item)[1].toLocaleString('en-IN') : (getPrice(item)[1] |
                    number:'1.2-2') }} ₹
                </span>
            </div>
            <div class="price" *ngIf="getPrice(item).length === 1">
                <!-- {{getPrice(item)[0]}} ₹ -->
                {{ getPrice(item)[0] % 1 === 0 ? getPrice(item)[0].toLocaleString('en-IN') : (getPrice(item)[0] |
                number:'1.2-2') }} ₹
            </div>
        </div>
    </div>
    <!-- 
    <div class="priceAndLike">
        <p class="price">
            <ng-container *ngIf="getPrice(item).length > 1">
                {{getPrice(item)[0]}} ₹
                <span class="finalPrice"> {{getPrice(item)[1]}} ₹ </span>
            </ng-container>
            <ng-container *ngIf="getPrice(item).length === 1">
                {{getPrice(item)[0]}} ₹
            </ng-container>
        </p>
    </div> -->

</div>